const COMMIT_SHA_LABEL_LENGTH = 7;
const UPDATE_ID_LABEL_LENGTH = 8;

export interface BuildLabelParts {
  buildNumber?: string | null;
  commitSha?: string | null;
  updateId?: string | null;
  version: string;
}

/**
 * Format a human-readable build label from version/build metadata.
 * Each optional segment is appended only when present and non-empty; absent
 * segments are omitted entirely (no placeholder).
 *
 * @example formatBuildLabel({ version: '2.0.0' })                                        // 'v2.0.0'
 * @example formatBuildLabel({ version: '2.0.0', buildNumber: '12' })                      // 'v2.0.0 (12)'
 * @example formatBuildLabel({ version: '2.0.0', commitSha: '5a17cfbabc' })                // 'v2.0.0 - 5a17cfb'
 * @example formatBuildLabel({ version: '2.0.0', updateId: 'a1b2c3d4e5f6' })               // 'v2.0.0 · a1b2c3d4'
 */
export function formatBuildLabel(parts: BuildLabelParts): string {
  const { buildNumber, commitSha, updateId, version } = parts;
  const segments = [`v${version}`];

  if (buildNumber) {
    segments.push(`(${buildNumber})`);
  }
  if (commitSha) {
    segments.push(`- ${commitSha.slice(0, COMMIT_SHA_LABEL_LENGTH)}`);
  }
  if (updateId) {
    segments.push(`· ${updateId.slice(0, UPDATE_ID_LABEL_LENGTH)}`);
  }

  return segments.join(' ');
}
